export const getUserDisplayName = (user, fallback = 'User') =>
  user?.name || user?.phone || user?.email || fallback